import { Component, OnInit, inject } from '@angular/core';
import { SeoService } from '../../core/services/seo.service';

@Component({
  selector: 'app-privacidad',
  standalone: true,
  templateUrl: './privacidad.component.html',
})
export class PrivacidadComponent implements OnInit {
  private seo = inject(SeoService);

  ngOnInit(): void {
    this.seo.setMetaTags({
      title: 'Política de privacidad — Chambia',
      description: 'Conoce cómo Chambia protege y utiliza tus datos personales.',
      path: '/privacidad',
    });
  }
}
